<div appScrollToTop class="wrapper-app" [class.sidebar-collapsed]="sidebarCollapsed">
  <app-header></app-header>
  <div class="app-body">
    <div class="app-content-wrapper">
      <main class="content">
        <router-outlet></router-outlet>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</div>
